/* Pampino Produktseite: Galerie, Varianten, Sticky-Karte */
(function () {
  var root = document.querySelector('[data-pdp]');
  if (!root) return;
  var data = JSON.parse(root.querySelector('[data-pdp-json]').textContent);

  /* Galerie */
  var gal = root.querySelector('[data-gallery]');
  var track = gal.querySelector('[data-track]');
  var main = gal.querySelector('.pp-gal__main');
  var slides = Array.prototype.slice.call(track.children);
  var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-thumb]'));
  var prev = gal.querySelector('[data-prev]');
  var next = gal.querySelector('[data-next]');
  var idx = 0;

  function go(i) {
    if (!slides.length) return;
    idx = Math.max(0, Math.min(slides.length - 1, i));
    track.style.transform = 'translateX(' + (-idx * 100) + '%)';
    slides.forEach(function (s, n) {
      s.classList.toggle('is-active', n === idx);
      s.setAttribute('aria-hidden', n !== idx ? 'true' : 'false');
    });
    thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === idx ? 'true' : 'false'); });
    if (prev) prev.disabled = idx === 0;
    if (next) next.disabled = idx === slides.length - 1;
    var t = thumbs[idx];
    if (t) t.parentNode.scrollTo({ left: t.offsetLeft - t.parentNode.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
  }

  if (prev) prev.addEventListener('click', function () { go(idx - 1); });
  if (next) next.addEventListener('click', function () { go(idx + 1); });
  thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });

  var startX = null;
  main.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') startX = e.clientX; });
  main.addEventListener('pointerup', function (e) {
    if (startX === null) return;
    var dx = e.clientX - startX;
    if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
    startX = null;
  });
  main.addEventListener('pointercancel', function () { startX = null; });

  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    main.addEventListener('mousemove', function (e) {
      if (e.target.closest('button, .pp-gal__flag')) { main.classList.remove('is-zoom'); return; }
      var r = main.getBoundingClientRect();
      var img = slides[idx] && slides[idx].querySelector('img');
      if (img) img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      main.classList.add('is-zoom');
    });
    main.addEventListener('mouseleave', function () { main.classList.remove('is-zoom'); });
  }

  go(data.startMedia > 0 ? data.startMedia : 0);

  /* Varianten */
  var form = document.getElementById('pp-product-form');
  var idInput = form && form.querySelector('[name="id"]');

  function setText(sel, text) { document.querySelectorAll(sel).forEach(function (el) { el.textContent = text; }); }
  function setHidden(sel, hidden) { document.querySelectorAll(sel).forEach(function (el) { el.hidden = hidden; }); }

  root.addEventListener('change', function (e) {
    var input = e.target.closest('[data-swatch]');
    if (!input) return;
    var v = data.variants.filter(function (x) { return String(x.id) === input.value; })[0];
    if (!v) return;
    if (idInput) idInput.value = v.id;
    setText('[data-price]', v.price);
    setText('[data-was]', v.compare || '');
    setHidden('[data-was]', !v.compare);
    setText('[data-save]', v.save ? 'Spare ' + v.save + '%' : '');
    setHidden('[data-save]', !v.save);
    setText('[data-option-label]', v.label);
    document.querySelectorAll('[data-atc]').forEach(function (b) {
      b.disabled = !v.available;
      var l = b.querySelector('[data-atc-label]');
      if (l) l.textContent = v.available ? data.strings.add : data.strings.soldOut;
    });
    var img = document.querySelector('[data-sticky-img]');
    if (img && v.thumb) img.src = v.thumb;
    if (window.history.replaceState) window.history.replaceState(null, '', '?variant=' + v.id);
    if (v.media >= 0) go(v.media);
  });

  /* Sticky Add-to-Cart: sichtbar, sobald der Kauf-Button oben aus dem Bild ist */
  var sticky = document.querySelector('[data-sticky]');
  var mainAtc = root.querySelector('[data-atc-main]');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(mainAtc);
  }
})();
